import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { useFundingApplication, useFundingApplicationMutation } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { useStageOptOutCheckbox } from "../hooks";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const PoolBancarioDocumentUpload = ({
  error,
  showConstraints,
  variant = "compact",
}: {
  error?: string;
  showConstraints?: boolean;
  variant?: "dropzone" | "compact";
}): UIElement => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: fundingApplication } = useFundingApplication(customerDomain);
  const fundingApplicationMutation = useFundingApplicationMutation(customerDomain);
  const { canOptOutOfStage } = useStageOptOutCheckbox(UploadDocumentType.POOL_BANCARIO);

  const handleSkipCheckbox = async (checked: boolean) => {
    await fundingApplicationMutation.mutateAsync({ id: fundingApplication.id, isPoolBancarioSkipped: checked });
  };

  return (
    <DocumentUpload
      documentType={UploadDocumentType.POOL_BANCARIO}
      supportedFileExtensions={[".xlsx", ".pdf"]}
      fileSizeLimitMB={50}
      fieldLabel={intl.formatMessage(MESSAGES.poolBancarioTitle)}
      onSkipCheckbox={canOptOutOfStage ? handleSkipCheckbox : undefined}
      skipCheckboxDescription={intl.formatMessage(MESSAGES.documentSkipCheckboxLabel)}
      skipped={canOptOutOfStage ? fundingApplication.isPoolBancarioSkipped : undefined}
      error={error}
      variant={variant}
      showHelpText={false}
      showConstraints={showConstraints}
    />
  );
};
